'use client';

import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { LINK } from '@constants';
import { useGlobalModalStore } from 'app/_hook/useGlobalModalStore';
import { useRouter } from 'next/navigation';

export const useCheckLogin = () => {
  const router = useRouter();
  const { accessToken } = useTokenStore();
  const { getValue } = useGlobalModalStore();
  const { setConfirmModal } = getValue('actions');

  return (link: string) => {
    if (!accessToken) {
      return setConfirmModal({
        content: `본 서비스는 회원만 이용이 가능해요.\n로그인할까요?`,
        hasCloseButton: false,
        onClickFillButton: () => {
          router.push(LINK.LOGIN);
        },
      });
    }
    return link && router.push(link);
  };
};
